const $ = require('jquery');
import run from '../../utilities/run';
import render from "../../utilities/render";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
const modalHtml = require("../../sharedHtml/modal.html");
const ctStateModalHtml = require("./html/onLoadModalBody.html");
require("./fxoReceivingScreen.less");

export default function FxoReceivingHomePageLogic(mainEl) {
  const self = this;
  const fxoSearchRetailerNameFm = $('#fxo-search-retailer-name');
  const fxoSearchRetailerNameHidden = $('.fxo-search-retailer-name-hidden');
  const fxoContinueSubmitCtModal = $('.fxo-continue-submit-ct-modal');

  self.init = function() {
    bindElements();
    checkCtStateCondition();
    fxoContinueSubmitCtModal.val('');
  };

  function bindElements() {
    fxoSearchRetailerNameFm.on("click",'.continue-att-return', continueAttBtnClick);
  }

  const ctStateModal = $(render(
    modalHtml,
    {
      modalDialogClass: 'q-modal-dialog-500',
      title: 'Equipment Confirmation',
      leftAlignTitle: true,
      body: ctStateModalHtml,
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide cancel-rtn-btn">Cancel Return</a> <a href="#" class="base-btn purple-btn continue-att-return">Continue AT&T Return</a>'
    }
  ));
  fxoSearchRetailerNameFm.append(ctStateModal);

  function checkCtStateCondition() {
      let checkCondition = fxoSearchRetailerNameFm.data('ct-state-condition-ret-name');
      if(checkCondition != '') {
          fxoSearchRetailerNameHidden.val(checkCondition);
          ctStateModal.modal("show");
      } else {
          ctStateModal.modal("hide");
      }
  }

  function continueAttBtnClick() {
      fxoContinueSubmitCtModal.val('true');
      fxoSearchRetailerNameFm.submit();
  }
}



// WEBPACK FOOTER //
// ./src/pages/fxoReceivingScreen/fxoReceivingHomePageLogic.js